import { Court } from '../types/venue'

export const courts: Court[] = [
  // Lamunin Pickleball Courts
  {
    id: 'lamunin-court-1',
    venueId: 'lamunin',
    name: 'Court 1',
    courtNumber: 1,
    rating: 4.8,
    reviews: 6,
    images: [
      'https://uploadthingy.s3.us-west-1.amazonaws.com/9kkuUyBCwXcXfWGTqXGwqZ/CourtImageRotate1.webp',
      'https://uploadthingy.s3.us-west-1.amazonaws.com/9kkuUyBCwXcXfWGTqXGwqZ/CourtImageRotate1.webp',
    ],
    surface: 'Premium Padel',
    lighting: 'LED Floodlights',
    netQuality: 'Professional',
    amenities: 'Water, Seating',
    type: 'Indoor',
    priceUC: 15,
    price: 15,
    peakPriceUC: 20,
    peakPrice: 20,
  },
  {
    id: 'lamunin-court-2',
    venueId: 'lamunin',
    name: 'Court 2',
    courtNumber: 2,
    rating: 4.7,
    reviews: 5,
    images: [
      'https://uploadthingy.s3.us-west-1.amazonaws.com/9kkuUyBCwXcXfWGTqXGwqZ/CourtImageRotate1.webp',
    ],
    surface: 'Premium Padel',
    lighting: 'LED Floodlights',
    netQuality: 'Professional',
    amenities: 'Water, Seating',
    type: 'Indoor',
    priceUC: 15,
    price: 15,
    peakPriceUC: 20,
    peakPrice: 20,
  },
  {
    id: 'lamunin-court-3',
    venueId: 'lamunin',
    name: 'Court 3',
    courtNumber: 3,
    rating: 4.6,
    reviews: 4,
    images: [
      'https://uploadthingy.s3.us-west-1.amazonaws.com/9kkuUyBCwXcXfWGTqXGwqZ/CourtImageRotate1.webp',
    ],
    surface: 'Standard Padel',
    lighting: 'LED Floodlights',
    netQuality: 'Standard',
    amenities: 'Water, Shade',
    type: 'Indoor',
    priceUC: 15,
    price: 15,
    peakPriceUC: 20,
    peakPrice: 20,
  },
  {
    id: 'lamunin-court-4',
    venueId: 'lamunin',
    name: 'Court 4',
    courtNumber: 4,
    rating: 4.5,
    reviews: 3,
    images: [
      'https://uploadthingy.s3.us-west-1.amazonaws.com/9kkuUyBCwXcXfWGTqXGwqZ/CourtImageRotate1.webp',
    ],
    surface: 'Standard Padel',
    lighting: 'LED Floodlights',
    netQuality: 'Standard',
    amenities: 'Water, Shade',
    type: 'Indoor',
    priceUC: 15,
    price: 15,
    peakPriceUC: 20,
    peakPrice: 20,
  },
  {
    id: 'lamunin-court-5',
    venueId: 'lamunin',
    name: 'Court 5',
    courtNumber: 5,
    rating: 4.9,
    reviews: 8,
    images: [
      'https://uploadthingy.s3.us-west-1.amazonaws.com/9kkuUyBCwXcXfWGTqXGwqZ/CourtImageRotate1.webp',
    ],
    surface: 'Pickleball Court',
    lighting: 'LED Floodlights',
    netQuality: 'Professional',
    amenities: 'Water, Seating, Equipment',
    type: 'Indoor',
    priceUC: 15,
    price: 15,
    peakPriceUC: 20,
    peakPrice: 20,
  },
  {
    id: 'lamunin-court-6',
    venueId: 'lamunin',
    name: 'Court 6',
    courtNumber: 6,
    rating: 4.8,
    reviews: 7,
    images: [
      'https://uploadthingy.s3.us-west-1.amazonaws.com/9kkuUyBCwXcXfWGTqXGwqZ/CourtImageRotate1.webp',
    ],
    surface: 'Pickleball Court',
    lighting: 'LED Floodlights',
    netQuality: 'Professional',
    amenities: 'Water, Seating, Equipment',
    type: 'Indoor',
    priceUC: 15,
    price: 15,
    peakPriceUC: 20,
    peakPrice: 20,
  },
  // Gadong Sports Complex Courts
  {
    id: 'gadong-court-1',
    venueId: 'gadong',
    name: 'Court 1',
    courtNumber: 1,
    rating: 4.7,
    reviews: 12,
    images: [
      'https://images.unsplash.com/photo-1554068865-24cecd4e34b8?w=800&h=600&fit=crop',
    ],
    surface: 'Premium Synthetic',
    lighting: 'LED Pro',
    netQuality: 'Professional',
    amenities: 'AC, Water, Seating',
    type: 'Indoor',
    priceUC: 18,
    price: 18,
    peakPriceUC: 25,
    peakPrice: 25,
  },
  {
    id: 'gadong-court-2',
    venueId: 'gadong',
    name: 'Court 2',
    courtNumber: 2,
    rating: 4.6,
    reviews: 10,
    images: [
      'https://images.unsplash.com/photo-1554068865-24cecd4e34b8?w=800&h=600&fit=crop',
    ],
    surface: 'Premium Synthetic',
    lighting: 'LED Pro',
    netQuality: 'Professional',
    amenities: 'AC, Water, Seating',
    type: 'Indoor',
    priceUC: 18,
    price: 18,
    peakPriceUC: 25,
    peakPrice: 25,
  },
  {
    id: 'gadong-court-3',
    venueId: 'gadong',
    name: 'Court 3',
    courtNumber: 3,
    rating: 4.5,
    reviews: 8,
    images: [
      'https://images.unsplash.com/photo-1554068865-24cecd4e34b8?w=800&h=600&fit=crop',
    ],
    surface: 'Standard Synthetic',
    lighting: 'LED',
    netQuality: 'Standard',
    amenities: 'Water, Seating',
    type: 'Indoor',
    priceUC: 18,
    price: 18,
    peakPriceUC: 25,
    peakPrice: 25,
  },
  {
    id: 'gadong-court-4',
    venueId: 'gadong',
    name: 'Court 4',
    courtNumber: 4,
    rating: 4.4,
    reviews: 7,
    images: [
      'https://images.unsplash.com/photo-1554068865-24cecd4e34b8?w=800&h=600&fit=crop',
    ],
    surface: 'Standard Synthetic',
    lighting: 'LED',
    netQuality: 'Standard',
    amenities: 'Water, Seating',
    type: 'Indoor',
    priceUC: 18,
    price: 18,
    peakPriceUC: 25,
    peakPrice: 25,
  },
  // Berakas Sports Complex Courts (8 courts)
  ...Array.from({ length: 8 }, (_, i) => ({
    id: `berakas-court-${i + 1}`,
    venueId: 'berakas',
    name: `Court ${i + 1}`,
    courtNumber: i + 1,
    rating: 4.8 + Math.random() * 0.2,
    reviews: Math.floor(Math.random() * 20) + 10,
    images: [
      'https://images.unsplash.com/photo-1622163642998-1ea32b0bbc67?w=800&h=600&fit=crop',
    ],
    surface: i < 4 ? 'Tournament Grade' : 'Premium Synthetic',
    lighting: 'Professional LED',
    netQuality: 'Professional',
    amenities: 'Locker, Water, Seating',
    type: (i < 6 ? 'Indoor' : 'Outdoor') as 'Indoor' | 'Outdoor',
    priceUC: 20,
    price: 20,
    peakPriceUC: 30,
    peakPrice: 30,
  })),
  // Seria Recreation Club Courts
  {
    id: 'seria-court-1',
    venueId: 'seria',
    name: 'Court 1',
    courtNumber: 1,
    rating: 4.6,
    reviews: 15,
    images: [
      'https://images.unsplash.com/photo-1617883861744-5a4a37f0e1f0?w=800&h=600&fit=crop',
    ],
    surface: 'Outdoor Synthetic',
    lighting: 'Natural + LED',
    netQuality: 'Standard',
    amenities: 'Water, Shade',
    type: 'Outdoor',
    priceUC: 12,
    price: 12,
    peakPriceUC: 18,
    peakPrice: 18,
  },
  {
    id: 'seria-court-2',
    venueId: 'seria',
    name: 'Court 2',
    courtNumber: 2,
    rating: 4.5,
    reviews: 12,
    images: [
      'https://images.unsplash.com/photo-1617883861744-5a4a37f0e1f0?w=800&h=600&fit=crop',
    ],
    surface: 'Outdoor Synthetic',
    lighting: 'Natural + LED',
    netQuality: 'Standard',
    amenities: 'Water, Shade',
    type: 'Outdoor',
    priceUC: 12,
    price: 12,
    peakPriceUC: 18,
    peakPrice: 18,
  },
  {
    id: 'seria-court-3',
    venueId: 'seria',
    name: 'Court 3',
    courtNumber: 3,
    rating: 4.4,
    reviews: 10,
    images: [
      'https://images.unsplash.com/photo-1617883861744-5a4a37f0e1f0?w=800&h=600&fit=crop',
    ],
    surface: 'Outdoor Synthetic',
    lighting: 'Natural + LED',
    netQuality: 'Standard',
    amenities: 'Water, Shade',
    type: 'Outdoor',
    priceUC: 12,
    price: 12,
    peakPriceUC: 18,
    peakPrice: 18,
  },
]

export function getCourtsByVenueId(venueId: string): Court[] {
  return courts.filter((c) => c.venueId === venueId)
}

export function getCourtById(courtId: string): Court | undefined {
  return courts.find((c) => c.id === courtId)
}
